import React from "react";

const scrollingImages = [
  // MSP Partners
  [
    { src: "assets/msp/29.png", alt: "MSP Partner 1" },
    { src: "assets/msp/29 (2).png", alt: "MSP Partner 2" },
    { src: "assets/msp/29 (3).png", alt: "MSP Partner 3" },
    { src: "assets/msp/29 (4).png", alt: "MSP Partner 4" },
    // { src: "assets/msp/29 (6).png", alt: "MSP Partner 5" },
  ],
  // Media Partners
  [
    { src: "assets/media/29_(2).png", alt: "Media Partner 1" },
    { src: "assets/media/29_(3).png", alt: "Media Partner 2" },
    { src: "assets/media/29.png", alt: "Media Partner 3" },
  ],
  // Extra column for visual balance
  [
    { src: "assets/msp/29 (3).png", alt: "MSP Partner 3" },
    { src: "assets/media/29_(2).png", alt: "Media Partner 1" },
    { src: "assets/msp/29.png", alt: "MSP Partner 1" },
    //  { src: "assets/media/29(6).png", alt: "Media Partner 3" },
    { src: "assets/media/29.png", alt: "Media Partner 3" },
  ],
];

const TechnologyPartners = () => {
  return (
    <section className="relative bg-gradient-to-br from-[#2642B2] via-indigo-900 to-slate-900 text-white py-12 md:py-20">
      {/* Optional subtle background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-gradient-to-tr from-blue-600 via-transparent to-purple-600"></div>
      </div>

      {/* Main Heading */}
      <div className="container mx-auto px-4 mb-12 md:mb-20 relative z-10">
        <div className="text-center max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-8">
            Our Technology Partners
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed px-4 md:px-0">
            We collaborate with industry-leading technology partners to deliver enterprise-grade
            solutions built on innovation, security, and exceptional service.
          </p>
        </div>
      </div>

      {/* Main Layout: Left Text + Right Scrolling */}
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-center">
            {/* LEFT SIDE: Text Content - Takes 50% width on desktop */}
            <div className="lg:w-1/2 order-2 lg:order-1 lg:pr-12">
              {/* MSP Partners Section */}
              <div className="mb-12 md:mb-16 text-center lg:text-left">
                <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">
                  MSP Partners
                </h3>
                <p className="text-base md:text-lg text-gray-200 leading-relaxed">
                  Authorized MSP Partner with Industry Leaders – Powering Smart, 
                  Scalable Technology Solutions with certified expertise and 24/7 support.
                </p>
              </div>

              {/* Media Partners Section */}
              <div className="text-center lg:text-left">
                <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">
                  Authorized International Media Partner
                </h3>
                <p className="text-base md:text-lg text-gray-200 mb-8 leading-relaxed">
                  Global media reach with enterprise-grade execution.
                </p>

                {/* Enhanced Stats Cards */}
                <div className="flex flex-col sm:flex-row gap-4 md:gap-8 max-w-sm md:max-w-md mx-auto lg:mx-0">
                  <div className="flex-1 bg-white/10 backdrop-blur-md border border-white/20 p-6 md:p-8 rounded-xl md:rounded-2xl text-center shadow-lg md:shadow-2xl hover:bg-white/20 transition-all duration-300">
                    <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-cyan-400 mb-2">
                      100+
                    </div>
                    <div className="text-sm md:text-base lg:text-lg text-gray-200 font-semibold">
                      Countries
                    </div>
                  </div>
                  <div className="flex-1 bg-white/10 backdrop-blur-md border border-white/20 p-6 md:p-8 rounded-xl md:rounded-2xl text-center shadow-lg md:shadow-2xl hover:bg-white/20 transition-all duration-300">
                    <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-cyan-400 mb-2">
                      500+
                    </div>
                    <div className="text-sm md:text-base lg:text-lg text-gray-200 font-semibold">
                      Campaigns
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT SIDE: Scrolling Logos - Takes 50% width on desktop */}
            <div className="lg:w-1/2 order-1 lg:order-2 mb-10 lg:mb-0 lg:pl-12">
              <div className="parent">
                <div className="columns-wrapper">
                  {scrollingImages.map((columnImages, columnIndex) => (
                    <div key={columnIndex} className="image-column">
                      <div className={`track ${columnIndex % 2 === 0 ? "up" : "down"}`}>
                        {[...columnImages, ...columnImages].map((img, imgIndex) => (
                          <div
                            key={`${columnIndex}-${imgIndex}`}
                            className="image-container"
                          >
                            <img
                              src={img.src}
                              alt={img.alt}
                              className="partner-image"
                              loading="lazy"
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Enhanced CSS */}
      <style jsx>{`
  .parent {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }

  .columns-wrapper {
    display: flex;
    gap: 30px;
    transform: rotate(-10deg);
  }

  /* 🔥 KEY FIX: increase height */
  .image-column {
    height: 650px;   /* ⬅ was 400px */
    width: 160px;
    overflow: hidden;
    border-radius: 20px;
  }

  .track {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .image-container {
    flex-shrink: 0;
    height: 180px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px;
  }

  .partner-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: drop-shadow(0 10px 20px rgba(0,0,0,0.3));
  }

  /* 🔥 KEY FIX: move full height */
  .up {
    animation: scrollUp 10s linear infinite;
  }

  .down {
    animation: scrollDown 10s linear infinite;
  }

  @keyframes scrollUp {
    from { transform: translateY(0); }
    to { transform: translateY(-100%); }
  }

  @keyframes scrollDown {
    from { transform: translateY(-100%); }
    to { transform: translateY(0); }
  }

  .image-column:hover .track {
    animation-play-state: paused;
  }

  /* 📱 Mobile */
  @media (max-width: 768px) {
    .columns-wrapper {
      transform: rotate(-5deg);
    }

    .image-column {
      height: 520px;
      width: 130px;
    }

    .image-container {
      height: 140px;
    }
  }

  @media (max-width: 480px) {
    .columns-wrapper {
      transform: rotate(0deg);
    }

    .image-column {
      height: 460px;
      width: 110px;
    }

    .image-container {
      height: 120px;
    }
  }
`}</style>

    </section>
  );
};

export default TechnologyPartners;